export enum Type {
  TEXT_PRESETS_REQUEST = 'app/text-presets/TEXT_PRESETS_REQUEST',
  TEXT_PRESETS_REQUEST_FAILURE = 'app/text-presets/TEXT_PRESETS_REQUEST_FAILURE',
  TEXT_PRESETS_REQUEST_SUCCESS = 'app/text-presets/TEXT_PRESETS_REQUEST_SUCCESS',
}
